import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { cx } from '@emotion/css';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { useSubsidiary } from '@phoenix/core/frontend/shared/feature/customer-support/use-subsidiary';
import { useCustomerSupportLink } from '@phoenix/team-m/my-tool-shed/frontend/shared/use-customer-support-link';
import { OverviewSection } from '@phoenix/team-m/dashboard/frontend/ui/overview/overview-section';
import { CustomerSupportCard } from '@phoenix/team-m/dashboard/frontend/ui/customer-support/customer-support-card';

export const CustomerSupportSection: FC = () => {
  const { t } = useTranslation();
  const { data: subsidiary } = useSubsidiary();

  return (
    <OverviewSection headline={t('dashboard_contact_headline')} dataTestId="customer-support">
      <div className="flex flex-col gap-6 pt-8 desktop:flex-row">
        <CustomerSupportCard
          className={cx({ 'desktop:flex-row': !subsidiary?.publicTelephone })}
          imageSrc="store-support-guy.webp"
          title={t('dashboard_contact_supportForm_headline')}
          icon="icon-envelope-16.svg"
          hyperLink={useCustomerSupportLink()}
          dataTestId="contact-us-card"
        >
          {t('dashboard_contact_supportForm_paragraph')}
        </CustomerSupportCard>
        {subsidiary?.publicTelephone && (
          <CustomerSupportCard
            imageSrc="call-support.webp"
            title={t('dashboard_contact_call_headline')}
            icon="icon-phone-16.svg"
            dataTestId="call-us-card"
          >
            <a href={`tel:${subsidiary.publicTelephone}`} className="stihl-text-body-lg-bold">
              {subsidiary.publicTelephone}
            </a>
            {subsidiary.publicTelephoneInfo && (
              <div className="stihl-text-body-sm-reg *:mb-4">{documentToReactComponents(subsidiary.publicTelephoneInfo.json)}</div>
            )}
            <p className="mt-6">{t('dashboard_contact_call_paragraph')}</p>
          </CustomerSupportCard>
        )}
      </div>
    </OverviewSection>
  );
};
